var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExample = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.5 1.5H22.5V10.5L13.5 1.5ZM10.5 1.5L1.5 10.5V1.5H10.5ZM0 12V0H12H24V12V24H12H0V12ZM10.5 22.5H1.5V13.5L10.5 22.5ZM13.5 22.5H22.5V13.5L13.5 22.5ZM12 2.12128L21.8787 12L12 21.8787L2.12132 12L12 2.12128Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgExample);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/example.7980c7e2c59a6bb9343f4e66b724b336.svg";